import { classNames } from '../utilities';

export const DownArrowIcon = ({ fill = '#516F90', id, className, onClick }) => {
  return (
    <svg
      className={classNames(
        'down-arrow-icon cursor-pointer',
        className ? className : ''
      )}
      onClick={onClick ? onClick : () => null}
      width="13"
      height="10"
      viewBox="0 0 16 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.316205 0.897272C0.527008 0.693662 0.7766 0.591857 1.06498 0.591857C1.35336 0.591857 1.60267 0.693662 1.81291 0.897272L7.98946 6.86305L14.1871 0.876912C14.3838 0.686876 14.6298 0.591858 14.9249 0.591858C15.22 0.591858 15.473 0.693663 15.6838 0.897273C15.8946 1.10088 16 1.34196 16 1.6205C16 1.89903 15.8946 2.13984 15.6838 2.3429L8.57971 9.1842C8.49539 9.26565 8.40404 9.32347 8.30566 9.35768C8.20729 9.39188 8.10189 9.40872 7.98946 9.40817C7.87703 9.40817 7.77163 9.39107 7.67325 9.35686C7.57488 9.32266 7.48353 9.2651 7.39921 9.1842L0.295125 2.32254C0.0983753 2.13251 -5.82925e-08 1.89822 -4.58636e-08 1.61968C-3.34346e-08 1.34114 0.105401 1.10034 0.316205 0.897272Z"
        fill="black"
      />
    </svg>
  );
};
